import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import { Grid, Button, Box } from '@mui/material';
import Divider from '@mui/material/Divider';

import { DialogTitleWithClose, FileUploaderInput } from 'ui';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  paper: {
    minWidth: 600,
  },
});

export const ShopProductDocumentsModal = ({ setFieldValue, open, onClose, documents }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const orderForm = documents && documents.find(({ name }) => name === 'Order form.pdf');
  const productDescription =
    documents && documents.find(({ name }) => name === 'Product description.pdf');
  const termsAndConditions =
    documents && documents.find(({ name }) => name === 'Terms and conditions.pdf');

  const handleSubmit = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" classes={{ paper: classes.paper }}>
      <DialogTitleWithClose onClose={onClose}>{t('Documents upload')}</DialogTitleWithClose>
      <DialogContent>
        <div className={classes.root}>
          <Divider />
          <Box p={2}>
            <Typography>{`${t('File format')}: .pdf`}</Typography>
            <Typography>{`${t('Max size')}: 5 MB`}</Typography>
          </Box>
          <Divider />
          <Box pt={2}>
            <Typography>{t('Order form:')}</Typography>
            <FileUploaderInput
              setFieldValue={setFieldValue}
              name="orderForm"
              document={orderForm}
            />
            <Typography>{t('Product description:')}</Typography>
            <FileUploaderInput
              setFieldValue={setFieldValue}
              name="productDescription"
              document={productDescription}
            />
            <Typography>{t('Terms & conditions:')}</Typography>
            <FileUploaderInput
              setFieldValue={setFieldValue}
              name="termsAndConditions"
              document={termsAndConditions}
            />
          </Box>
          <Box mt={2}>
            <Grid container justifyContent="flex-end">
              <Button color="primary" variant="contained" type="submit" onClick={handleSubmit}>
                {t('Save')}
              </Button>
            </Grid>
          </Box>
        </div>
      </DialogContent>
    </Dialog>
  );
};

ShopProductDocumentsModal.defaultProps = {
  open: false,
  setFieldValue: () => null,
  onClose: () => null,
  documents: undefined,
};

ShopProductDocumentsModal.propTypes = {
  open: PropTypes.bool,
  setFieldValue: PropTypes.func,
  onClose: PropTypes.func,
  documents: PropTypes.array,
};
